import React from 'react';
import { PhoneCard } from './PhoneCard';
import type { PhonesListProps } from '../model/types';
export const PhonesList: React.FC<PhonesListProps> = ({
  phones,
  onCall
}) => <section className="flex flex-col gap-2" data-sentry-component="PhonesList" data-sentry-source-file="PhoneList.tsx">
    {phones.map(phoneNumber => <PhoneCard key={phoneNumber.phone} phoneNumber={phoneNumber} onCall={() => onCall(phoneNumber)} />)}
  </section>;